import { render, staticRenderFns } from "./WinnerMenu.vue?vue&type=template&id=74aef892&lang=pug"
import script from "./WinnerMenu.vue?vue&type=script&lang=js"
export * from "./WinnerMenu.vue?vue&type=script&lang=js"
import style0 from "./WinnerMenu.vue?vue&type=style&index=0&id=74aef892&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports